import React from 'react'

interface Props {
  width?: string | number
  height?: string | number
  fillColor?: string
  strokeWidth?: string | number
  [x: string]: unknown
}

const DreamCloud: React.FunctionComponent<Props> = ({
  width = 104,
  height = 40,
  fillColor = '#1b222e',
  strokeWidth = '0',
  ...rest
}) => (
  <svg width={width} height={height} viewBox="0 0 188.571 76" {...rest}>
    <path
      d="M116.998,19.218c-2.05,0-3.957.597-5.572,1.615.212-1.089.331-2.211.331-3.362,0-9.649-7.822-17.471-17.471-17.471s-17.471,7.822-17.471,17.471c0,1.151.118,2.273.331,3.362-1.615-1.017-3.522-1.615-5.572-1.615-5.789,0-10.483,4.693-10.483,10.483,0,5.132,3.69,9.395,8.561,10.299-2.008-1.601-3.319-4.038-3.319-6.805,0-4.825,3.911-8.736,8.736-8.736,1.284,0,2.493.293,3.591.79.829.376,1.578.884,2.244,1.487-.262-.873-.441-1.781-.528-2.717-.04-.431-.066-.866-.066-1.307,0-7.719,6.258-13.977,13.977-13.977s13.977,6.258,13.977,13.977c0,.441-.026.876-.066,1.307-.087.936-.266,1.844-.528,2.717.667-.603,1.415-1.111,2.244-1.487,1.098-.497,2.307-.79,3.591-.79,4.825,0,8.736,3.911,8.736,8.736,0,2.767-1.312,5.204-3.319,6.805,4.87-.904,8.561-5.167,8.561-10.299,0-5.789-4.693-10.483-10.483-10.483Z"
      fill={fillColor}
      strokeWidth={strokeWidth}
    />
    <g>
      <path
        d="M0,60.265h5.37c4.862,0,8.221,3.337,8.221,7.691v.044c0,4.353-3.359,7.735-8.221,7.735H0v-15.47ZM5.37,74.122c3.912,0,6.409-2.652,6.409-6.078v-.044c0-3.426-2.497-6.122-6.409-6.122H1.746v12.243h3.624Z"
        fill={fillColor}
        strokeWidth={strokeWidth}
      />
      <path
        d="M20.09,60.265h6.652c1.901,0,3.425.575,4.397,1.547.752.752,1.194,1.835,1.194,3.05v.044c0,2.563-1.768,4.066-4.199,4.508l4.752,6.32h-2.145l-4.486-6.011h-4.419v6.011h-1.746v-15.47ZM26.586,68.155c2.321,0,3.978-1.193,3.978-3.182v-.044c0-1.901-1.458-3.05-3.955-3.05h-4.773v6.276h4.751Z"
        fill={fillColor}
        strokeWidth={strokeWidth}
      />
      <path
        d="M38.916,60.265h11.181v1.591h-9.435v5.282h8.441v1.591h-8.441v5.414h9.547v1.591h-11.292v-15.47Z"
        fill={fillColor}
        strokeWidth={strokeWidth}
      />
      <path
        d="M62.557,60.155h1.635l7.05,15.58h-1.879l-1.812-4.089h-8.42l-1.833,4.089h-1.791l7.05-15.58ZM66.867,70.077l-3.514-7.89-3.536,7.89h7.05Z"
        fill={fillColor}
        strokeWidth={strokeWidth}
      />
      <path
        d="M76.978,60.265h1.767l5.636,8.442,5.635-8.442h1.768v15.47h-1.746v-12.53l-5.636,8.287h-.088l-5.636-8.265v12.508h-1.701v-15.47Z"
        fill={fillColor}
        strokeWidth={strokeWidth}
      />
      <path
        d="M98.329,68.044v-.044c0-4.376,3.27-8,7.823-8,2.806,0,4.486.995,6.033,2.453l-1.193,1.282c-1.304-1.237-2.762-2.122-4.862-2.122-3.425,0-5.989,2.785-5.989,6.343v.044c0,3.58,2.585,6.387,5.989,6.387,2.121,0,3.514-.818,4.995-2.232l1.149,1.127c-1.613,1.635-3.381,2.718-6.188,2.718-4.464,0-7.757-3.514-7.757-7.956Z"
        fill={fillColor}
        strokeWidth={strokeWidth}
      />
      <path d="M118.126,60.265h1.746v13.857h8.706v1.613h-10.452v-15.47Z" fill={fillColor} strokeWidth={strokeWidth} />
      <path
        d="M132.892,68.044v-.044c0-4.266,3.204-8,7.911-8s7.867,3.691,7.867,7.956v.044c0,4.265-3.204,8-7.911,8s-7.867-3.69-7.867-7.956ZM146.858,68.044v-.044c0-3.514-2.564-6.387-6.099-6.387s-6.055,2.829-6.055,6.343v.044c0,3.513,2.564,6.387,6.099,6.387s6.055-2.829,6.055-6.343Z"
        fill={fillColor}
        strokeWidth={strokeWidth}
      />
      <path
        d="M154.952,69.26v-8.994h1.746v8.884c0,3.336,1.768,5.215,4.73,5.215,2.851,0,4.663-1.724,4.663-5.105v-8.994h1.746v8.862c0,4.508-2.586,6.851-6.453,6.851-3.824,0-6.431-2.343-6.431-6.718Z"
        fill={fillColor}
        strokeWidth={strokeWidth}
      />
      <path
        d="M174.98,60.265h5.37c4.862,0,8.221,3.337,8.221,7.691v.044c0,4.353-3.359,7.735-8.221,7.735h-5.37v-15.47ZM180.35,74.122c3.912,0,6.409-2.652,6.409-6.078v-.044c0-3.426-2.497-6.122-6.409-6.122h-3.624v12.243h3.624Z"
        fill={fillColor}
        strokeWidth={strokeWidth}
      />
    </g>
  </svg>
)

export default DreamCloud
